

class Ticket {

    constructor(data) {
        const { title, description, ticket_type, image, email, priority } = data

        this.title = title
        this.description = description
        this.email = email
        if (ticket_type)
            this.ticket_type = ticket_type.id || ticket_type
        if (priority)
            this.priority = priority.id || priority
        if (image?.file)
            this.image = image.file
    }
}

export default Ticket